import translationService from '@/services/translation.service'

class UniversityEntranceQualificationMapper {
  map(
    qualification: string | null,
    isBwQualification: boolean | null,
  ): string | null {
    const fachhochschulreife = translationService.translate(
      'options.diploma.Fachhochschulreife',
    )

    if (qualification === fachhochschulreife && isBwQualification === true) {
      return fachhochschulreife + ' BW'
    }

    return qualification
  }
}

export default new UniversityEntranceQualificationMapper()
